export const getSuccess = (state: any) => state.auth.success

export const getUser = (state: any) => state.auth.user

export const getLoading = (state: any) => state.auth.loading
